import { z } from 'zod';

/**
 * The workflows the test-send tooling can trigger — every workflow with an
 * `in_app_feed` step. Excluded by design: `digest` (batch-driven; a single
 * trigger renders nonsense) and the email-only external third-party flows
 * (`third-party-set-password` etc.).
 *
 * Deliberately dependency-free (zod only): the web imports this module at
 * runtime to decide which settings rows get a send-test button, so it must not
 * pull server-side code (`@trpc/server`, the Knock client) into the bundle.
 */
export const TEST_SEND_WORKFLOW_KEYS = [
  'action-delete',
  'action-due',
  'action-insert',
  'action-overdue',
  'action-update',
  'asset-delete',
  'asset-insert',
  'asset-update',
  'attestation-record-insert',
  'change-request-insert',
  'change-request-rejected',
  'control-delete',
  'control-insert',
  'control-test-due',
  'control-test-overdue',
  'control-update',
  'data-export-failed',
  'document-delete',
  'document-due',
  'document-insert',
  'document-overdue',
  'document-update',
  'indicator-due',
  'indicator-overdue',
  'issue-ai-triage-completed',
  'issue-delete',
  'issue-due',
  'issue-insert',
  'issue-overdue',
  'issue-update',
  'obligation-change-insert',
  'policy-approver',
  'policy-attestation-reminder',
  'policy-document-version-review-due',
  'policy-document-version-review-upcoming',
  'risk-assessment-due',
  'risk-assessment-overdue',
  'risk-delete',
  'risk-insert',
  'risk-update',
  'third-party-response-submitted',
] as const;

export type TestSendWorkflowKey = (typeof TEST_SEND_WORKFLOW_KEYS)[number];

export const isTestSendWorkflowKey = (
  key: string
): key is TestSendWorkflowKey =>
  // Widen the literal tuple to string[] so .includes accepts an arbitrary string.
  (TEST_SEND_WORKFLOW_KEYS as readonly string[]).includes(key);

export const testSendInputSchema = z.object({
  /** A single workflow to trigger; omitted = every test-send workflow. */
  workflowKey: z.enum(TEST_SEND_WORKFLOW_KEYS).optional(),
});
